const enterprise = {
    namespaced: true, // 启用命名空间，确保可以通过 attachment/saveCurrentId 调用
    state:{
        currentId:"",
        assignOptions:{}
    },
    mutations:{
        SET_CURRENTID:(state,info) =>{
            state.currentId = info
        },
        SET_ASSIGNOPTIONS:(state,info)=> {
            state.assignOptions = info
        }
    },
    actions:{
        saveCurrentId({commit},info){
            commit('SET_CURRENTID',info)
        },
        saveAssignOptions({commit},info){
            commit('SET_ASSIGNOPTIONS',info)
        }
    }
}

export default enterprise